"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var hexToRgb_1 = (0, tslib_1.__importDefault)(require("./hexToRgb"));
function transperentizeColor(color, alpha) {
    if (alpha === void 0) { alpha = 1; }
    var _a = (0, hexToRgb_1.default)(color), r = _a.r, g = _a.g, b = _a.b;
    return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")");
}
exports.default = transperentizeColor;
//# sourceMappingURL=transperentizeColor.js.map